"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationMediaLinkList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const NavigationMediaLink_1 = require("./NavigationMediaLink");
// grid grid-cols-1 gap-y-10 gap-x-6
const NavigationMediaLinkList = (props) => {
    const { menu: { children }, onMenuSelected, } = props;
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children.map((link, index) => ((0, jsx_runtime_1.jsx)("div", { className: "flex w-48 justify-center space-x-4 space-y-2 ", children: (0, jsx_runtime_1.jsx)(NavigationMediaLink_1.NavigationMediaLink, { link: link, onMenuSelected: onMenuSelected }) }, `${link.name}_${index}`))) }));
};
exports.NavigationMediaLinkList = NavigationMediaLinkList;
